import revive_payload_client_4sVQNw7RlN from "/ice/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/ice/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/ice/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/ice/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/ice/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/ice/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/ice/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/ice/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/ice/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/ice/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/ice/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import cookie_fY1uPxNcjB from "/ice/plugins/cookie.ts";
import directive_I6YZ1QHKAO from "/ice/plugins/directive.ts";
import fetch_14DdzPiXUB from "/ice/plugins/fetch.ts";
import i18n_VfGcjrvSkj from "/ice/plugins/i18n.ts";
import jsbrage_client_UDcMVgkAMV from "/ice/plugins/jsbrage.client.ts";
import router_client_W01CLn04zL from "/ice/plugins/router.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  cookie_fY1uPxNcjB,
  directive_I6YZ1QHKAO,
  fetch_14DdzPiXUB,
  i18n_VfGcjrvSkj,
  jsbrage_client_UDcMVgkAMV,
  router_client_W01CLn04zL
]